export default __webpack_public_path__ + "static/media/WallNotification_Montgomery-Picture.7c519132.png";